module.exports = {
  'hello': 'Hi',
  'hashtag': 'Insert your hashtag'
}



// WEBPACK FOOTER //
// ./locales/en/index.js